import { styled, Theme } from "@material-ui/core";
import React from "react";
import ExpressDeliveryLogo from "../../../express-delivery/ExpressDeliveryLogo";

export type ProductExpressLabelType = "AGX" | "IN_STORE" | "COMING_SOON";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  whiteSpace: "nowrap",
  [theme.breakpoints.down("xs")]: {
    width: "100%",
    height: "26px",
    backgroundColor: theme.palette.grey[200]
  },
  "& .express-delivery-logo": {
    height: "12px",
    [theme.breakpoints.down("xs")]: {
      height: "10px"
    }
  }
}));

export const InStoreTypography = styled("span")(({ theme }) => ({
  fontWeight: 400,
  fontFamily: `Roobert`,
  letterSpacing: 0,
  lineHeight: `1.2rem`,
  fontSize: `1.2rem`,
  [theme.breakpoints.up("md")]: {
    lineHeight: `1.4rem`,
    fontSize: `1.4rem`
  },
  [theme.breakpoints.down("xs")]: {
    marginTop: "-2px"
  }
}));

type Props = {
  type: ProductExpressLabelType;
};

function ProductExpressLabel({ type }: Props) {
  return (
    <Wrapper>
      {type === "AGX" && <ExpressDeliveryLogo />}
      {type === "IN_STORE" && (
        <InStoreTypography>Available in-store</InStoreTypography>
      )}
      {type === "COMING_SOON" && (
        <InStoreTypography>Coming Soon</InStoreTypography>
      )}
    </Wrapper>
  );
}

export default React.memo(ProductExpressLabel);
